// eslint-disable-next-line import/prefer-default-export
export const ErrorGetToken = {
    ja: {
        0: '正常終了',
        1100: 'マーチャントID - 必須エラー',
        1200: 'トークン生成公開鍵 - 必須エラー',
        1201: 'トークン生成公開鍵 - 不正エラー',
        1300: 'カード番号 - 必須チェックエラー',
        1301: 'カード番号 - 書式チェックエラー',
        1400: '有効期限(年) - 必須チェックエラー',
        1401: '有効期限(年) - 書式チェックエラー',
        1500: '有効期限(月) - 必須チェックエラー',
        1501: '有効期限(月) - 書式チェックエラー',
        1502: '有効期限(年月)が不正です。 ',
        1600: 'セキュリティコード - 書式チェックエラー',
        1601: 'セキュリティコード - 必須エラー（セキュリティコードトークンの場合）',
        1700: 'カード名義 - 書式チェックエラー',
        7000: '非対応のブラウザです。',
        7001: 'ペイジェントとの通信に失敗しました。',
        8000: 'システムメンテナンス中です。',
        9000: 'ペイジェント決済システム内部エラー',
    },
    en: {
        0: 'Normal termination',
        1100: 'Merchant ID - Required error',
        1200: 'Token-generating public key - Required error',
        1201: 'Token generated public key - Bad error',
        1300: 'Card number - Required check error',
        1301: 'Card number - Format check error',
        1400: 'Expiration date (years) - Mandatory check error',
        1401: 'Expiration date (year) - Format check error',
        1500: 'Expiration date (months) - Mandatory check error',
        1501: 'Expiration date (months) - Format check error',
        1502: 'The expiration date (year and month) is invalid.',
        1600: 'Security code - Format check error',
        1601: 'Security code - Required error (for security code tokens)',
        1700: 'Cardholder - format check error',
        7000: 'Incompatible browser.',
        7001: 'Failed to communicate with paygent.',
        8000: 'System maintenance is in progress.',
        9000: 'Paygent payment system internal error',
    },
};

Object.freeze(ErrorGetToken);
